var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex align-items-center pl-1" }, [
    _c(
      "div",
      { staticClass: "text-center mr-1", staticStyle: { width: "40px" } },
      [
        !!_vm.picture.length
          ? _c("img", {
              attrs: { src: _vm.picture, width: "40", height: "40" },
            })
          : _c("i", { staticClass: "fa fa-mobile fa-2x text-muted" }),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mr-auto" }, [
      _c("h3", { staticClass: "text-md font-weight-bold mb-0 text-md" }, [
        _vm._v(_vm._s(_vm.item.name)),
      ]),
      _vm._v(" "),
      _vm.item.id
        ? _c(
            "div",
            { staticClass: "d-flex align-items-center text-gray-500 text-sm" },
            [
              _c(
                "span",
                { staticClass: "text-sm text-mono text-truncate text-muted" },
                [_vm._v(_vm._s(_vm.formatLicenceId(_vm.item.id)))]
              ),
            ]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "text-right" },
      [
        !_vm.item.slot1PhoneNumber && !_vm.item.slot2PhoneNumber
          ? _c(
              "div",
              {
                staticClass:
                  "alert alert-danger alert-sm p-1 pr-2 text-sm text-truncate",
              },
              [
                _c("i", { staticClass: "fa fa-exclamation-triangle mr-1" }),
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t("remoteMonitoring.device_status.missing_number")
                    ) +
                    "\n    "
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.status === "ERROR"
          ? _c("UiBadge", { attrs: { type: "danger" } }, [
              _vm._v(_vm._s(_vm.$t("remoteMonitoring.device_status.fail"))),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.status === "WAITING"
          ? _c("UiBadge", { attrs: { type: "info" } }, [
              _vm._v(_vm._s(_vm.$t("remoteMonitoring.device_status.waiting"))),
            ])
          : _vm._e(),
        _vm._v(" "),
        !!_vm.procedure
          ? _c("div", { staticClass: "text-sm text-muted" }, [
              _c("i", { staticClass: "fa fa-bullhorn mr-1" }),
              _vm._v(" " + _vm._s(_vm.procedure) + "\n    "),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }